module.exports = __webpack_public_path__ + "img/hn.hn519dcaf.svg";